module.exports = __webpack_public_path__ + "static/media/perimeter.dbafa0e2.png";